import localFont from '@next/font/local'
import { Roboto, Roboto_Condensed } from 'next/font/google'

export const robotoFonts = Roboto({
  variable: '--font-roboto',
  display: 'swap',
  subsets: ['latin'],
  weight: ['400', '700'],
})

export const robotoCondensedFonts = Roboto_Condensed({
  variable: '--font-roboto-condensed',
  display: 'swap',
  subsets: ['latin'],
  weight: ['400'],
})

export const gallardoFonts = localFont({
  variable: '--font-gallardo',
  display: 'swap',
  src: [
    { path: '../../public/fonts/Gallardo/gallardonormalweb-medium.woff2', weight: '500', style: 'normal' },
    { path: '../../public/fonts/Gallardo/gallardonormalweb-bold.woff2', weight: '700', style: 'normal' },
    { path: '../../public/fonts/Gallardo/gallardonormalweb-black.woff2', weight: '900', style: 'normal' },
    { path: '../../public/fonts/Gallardo/gallardonormalweb-ultra.woff2', weight: '950', style: 'normal' },
  ],
})
export const gallardoBold = localFont({
  variable: '--font-gallardo-bold',
  display: 'swap',
  src: [{ path: '../../public/fonts/Gallardo/gallardonormalweb-bold.woff2', weight: '700', style: 'normal' }],
})

export const shentoxFonts = localFont({
  variable: '--font-shentoxFont',
  display: 'swap',
  src: [{ path: '../../public/fonts/Shentox/Shentox-Bold.woff2', weight: '700', style: 'normal' }],
})

export const roboto = robotoFonts.style.fontFamily
export const robotoCondensed = robotoCondensedFonts.style.fontFamily
export const gallardo = gallardoFonts.style.fontFamily
export const gallardoBoldFamily = gallardoBold.style.fontFamily
export const shentox = shentoxFonts.style.fontFamily
